export default [
    {
        name: 'StoryDetailPageAbout',
        path: '',
        component: () => import(/* webpackChunkName: "story" */ './StoryDetailPageAbout'),
        props: true,
        meta: { name: 'about' },
    },
    {
        name: 'StoryDetailPageComments',
        path: 'comments',
        component: () => import(/* webpackChunkName: "story" */ './StoryDetailPageComments'),
        props: true,
        meta: { name: 'comments' },
    },
    {
        name: 'StoryDetailPageMembers',
        path: 'members',
        component: () => import(/* webpackChunkName: "story" */ './StoryDetailPageMembers'),
        props: true,
        meta: { name: 'members' },
    },
];
